define([
	"dojo/_base/declare",
	"dijit/Tooltip",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/view/ToolbarPluginMenu",
], function(declare, Tooltip, Action, ActionFactory, ToolbarPluginMenu) {

	const _Plugin = declare(ToolbarPluginMenu, {
		/** @proeprty {Tooltip} _dirtyTooltip - tooltip to display when custom view is dirty */
		_dirtyTooltip: null,

		/**
		 * @override
		 * Add tooltip when custom view is dirty
		 */
		enablePlugin: function(ctx) {
			const enabled = this.inherited(arguments);

			if (ctx) {
				let tooltip = this._dirtyTooltip;

				if (!enabled) {
					tooltip = tooltip || new Tooltip({
						connectId: this.domNode,
						label: this.defAction.getString("_Dirty")
					}).placeAt(ctx.view.getTooltipNode());
				} else if (tooltip) {
					tooltip.destroy();
					tooltip = null;
				}

				this._dirtyTooltip = tooltip;
			}

			return enabled;
		}
	});

	return ActionFactory.declare("CustomViewManage", Action, {
		classToolbarPlugin: _Plugin,

		/**
		 * @override
		 * Do not allow opening custom view dialog if view is dirty; this action will not be added to the view if the
		 * user does not have custom view edit permissions, so no need to check again here  
		 */
		hasAccess: function(ctx) {
			return !ctx.view.get("customViewDirty") && this.inherited(arguments);
		}
	});
});